<template>
  <map-view :map-center="mapCenter" class="neyos-tracker-map">
    <o-map-square-marker
      v-if="lastKnownLocation?.location"
      :label="label"
      iconName="map-marker"
      color="blue"
      :lat-lng="lastKnownLocation.location"
    />
  </map-view>
</template>

<script>
import { format } from 'date-fns'
import MapView from '@views/MapView/index.vue'
import OMapSquareMarker from '@components/Map/MapSquareMarker.vue'

export default {
  name: 'NeyosTrackerMap',

  components: {
    MapView,
    OMapSquareMarker,
  },

  props: {
    lastKnownLocation: {
      type: Object,
      required: false,
    },
  },

  computed: {
    mapCenter() {
      return this.lastKnownLocation ? this.lastKnownLocation.location : [0, 0]
    },

    label() {
      return this.lastKnownLocation
        ? `Dernière localisation le ${format(
            new Date(this.lastKnownLocation.locatedAt),
            'dd/MM/yyyy HH:mm',
          )}`
        : ''
    },
  },
}
</script>

<style lang="scss">
@import 'variables';
$map-view-min-height: 300px;

.neyos-tracker-map {
  height: 100%;
  min-height: $map-view-min-height;
}
</style>
